(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-condition-guide"] && !Shopify.designMode) return;
  try {
    
class LcConditionGuide {
  constructor(root) {
    this.root = root;
    this.panels = [...root.querySelectorAll('[data-grade-panel]')];
    this.links = [...root.querySelectorAll('[data-grade-link]')];
    this.dialog = root.querySelector('[data-zoom-dialog]');
    this.zoomImage = root.querySelector('[data-zoom-image]');
    this.viewport = root.querySelector('[data-zoom-viewport]');
    this.canvas = root.querySelector('[data-zoom-canvas]');
    this.level = 1;
    this.onHash = () => this.selectFromHash();
    this.onResize = () => { if (this.dialog.open) this.setZoom(this.level); };
    root.addEventListener('click', (event) => this.onClick(event));
    this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.previousOverflow || ''; this.opener?.focus({ preventScroll: true }); });
    this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } });
    this.zoomImage.addEventListener('load', () => this.setZoom(1));
    window.addEventListener('hashchange', this.onHash);
    window.addEventListener('resize', this.onResize);
    this.panels.forEach((panel) => { panel.querySelector('[data-game-controls]').hidden = false; this.selectGame(panel, 'pokemon'); });
    this.selectFromHash();
  }
  selectFromHash() {
    let id = window.location.hash.slice(1);
    if (id === 'good') id = 'slightly-played';
    if (!this.panels.some((panel) => panel.id === id)) id = this.panels.find((panel) => !panel.hidden)?.id || this.panels[0].id;
    this.selectGrade(id);
  }
  selectGrade(id) {
    this.panels.forEach((panel) => { panel.hidden = panel.id !== id; });
    this.links.forEach((link) => { if (link.dataset.gradeLink === id) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
  }
  selectGame(panel, game) {
    panel.querySelectorAll('[data-game]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.game === game)));
    panel.querySelectorAll('[data-photo-game]').forEach((figure) => { figure.hidden = figure.dataset.photoGame !== game; });
  }
  onClick(event) {
    const gradeLink = event.target.closest('[data-grade-link], [data-overview-link]');
    if (gradeLink) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const id = gradeLink.dataset.gradeLink || gradeLink.dataset.overviewLink;
      this.selectGrade(id);
      history.replaceState(null, '', '#' + id);
      if (gradeLink.hasAttribute('data-overview-link')) {
        const target = this.links.find((link) => link.dataset.gradeLink === id);
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      return;
    }
    const game = event.target.closest('[data-game]');
    if (game) { this.selectGame(game.closest('[data-grade-panel]'), game.dataset.game); return; }
    const photo = event.target.closest('[data-zoom-photo]');
    if (photo && typeof this.dialog.showModal === 'function') {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.opener = photo;
      this.level = 1;
      const img = photo.querySelector('img');
      this.zoomImage.alt = img.alt;
      this.root.querySelector('[data-zoom-title]').textContent = img.alt;
      this.zoomImage.src = photo.href;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.setZoom(1);
      this.root.querySelector('[data-zoom-close]').focus();
      return;
    }
    if (event.target.closest('[data-zoom-close]')) { this.dialog.close(); return; }
    const action = event.target.closest('[data-zoom-action]')?.dataset.zoomAction;
    if (action === 'in') this.setZoom(this.level + .5);
    if (action === 'out') this.setZoom(this.level - .5);
    if (action === 'reset') this.setZoom(1);
    if (action === 'edges') this.setZoom(3, 0, .5);
    if (action === 'corners') this.setZoom(3, 0, 0);
    if (action === 'surface') this.setZoom(3, .5, .5);
  }
  setZoom(level, x = .5, y = .5) {
    this.level = Math.min(4, Math.max(1, level));
    const ratio = (this.zoomImage.naturalWidth || 1800) / (this.zoomImage.naturalHeight || 2600);
    const baseHeight = Math.min(this.viewport.clientHeight - 36, (this.viewport.clientWidth - 36) / ratio);
    const width = baseHeight * ratio * this.level;
    const height = baseHeight * this.level;
    this.zoomImage.style.width = width + 'px';
    this.zoomImage.style.height = height + 'px';
    this.canvas.style.width = Math.max(this.viewport.clientWidth, width + 36) + 'px';
    this.canvas.style.height = Math.max(this.viewport.clientHeight, height + 36) + 'px';
    this.root.querySelector('[data-zoom-level]').value = Math.round(this.level * 100) + '%';
    this.root.querySelector('[data-zoom-action="out"]').disabled = this.level <= 1;
    this.root.querySelector('[data-zoom-action="in"]').disabled = this.level >= 4;
    this.viewport.scrollLeft = (this.viewport.scrollWidth - this.viewport.clientWidth) * x;
    this.viewport.scrollTop = (this.viewport.scrollHeight - this.viewport.clientHeight) * y;
  }
  destroy() { window.removeEventListener('hashchange', this.onHash); window.removeEventListener('resize', this.onResize); if (this.dialog.open) this.dialog.close(); }
}
const initConditionGuides = (scope = document) => { scope.querySelectorAll('[data-condition-guide]').forEach((root) => { if (!root.lcConditionGuide) root.lcConditionGuide = new LcConditionGuide(root); }); };
initConditionGuides();
document.addEventListener('shopify:section:load', (event) => initConditionGuides(event.target));
document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-condition-guide]').forEach((root) => root.lcConditionGuide?.destroy()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-lichguard-brand"]) return;
  try {
    
  if (!customElements.get('lichguard-collection')) {
    class LichguardCollection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.products = Array.from(this.querySelectorAll('[data-product-category]'));
        this.buttons = Array.from(this.querySelectorAll('[data-category]'));
        this.productSection = this.querySelector('[data-product-section]');
        this.canFilter = this.productSection && Number(this.productSection.dataset.pages) <= 1;
        if (!this.canFilter) return;
        const filters = this.querySelector('.lc-lg__filters');
        if (filters) filters.hidden = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-category]');
          if (button && this.contains(button)) this.filter(button.dataset.category);
          const link = event.target.closest('[data-category-link]');
          if (link && this.contains(link)) this.filter(link.dataset.categoryLink);
        });
      }
      filter(category) {
        let count = 0;
        this.products.forEach(product => {
          const matches = category === 'all' || product.dataset.productCategory.split(' ').includes(category);
          product.hidden = !matches;
          if (matches) count += 1;
        });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
        const status = this.querySelector('[data-product-count]');
        if (status) status.textContent = this.dataset.countTemplate.replace('[count]', String(count));
        const empty = this.querySelector('[data-filter-empty]');
        if (empty) empty.hidden = count !== 0;
      }
    }
    customElements.define('lichguard-collection', LichguardCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist-page"]) return;
  try {
    
(function () {
  'use strict';
  const instances = new Map();
  const normalize = value => String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().trim();

  function mount(section) {
    if (instances.has(section)) return;
    const view = section.querySelector('wishlist-view');
    const grid = section.querySelector('[data-wishlist-items-grid-display]');
    const tools = section.querySelector('[data-lc-wishlist-tools]');
    const search = section.querySelector('[data-lc-wishlist-search]');
    const sort = section.querySelector('[data-lc-wishlist-sort]');
    const results = section.querySelector('[data-lc-wishlist-results]');
    const noResults = section.querySelector('[data-lc-wishlist-no-results]');
    const reset = section.querySelector('[data-lc-wishlist-reset]');
    if (!view || !grid || !tools || !search || !sort || !results || !noResults || !reset) return;
    const collator = new Intl.Collator(document.documentElement.lang || 'nl', { sensitivity: 'base', numeric: true });
    let frame = 0;

    function refresh() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      if (!section.isConnected) return;
      const cards = Array.from(grid.children).filter(card => card.matches('[data-product-handle]'));
      const saved = Array.isArray(view.handles) ? view.handles : [];
      const storageError = !!window.lcWishlistStorageError;
      const busy = grid.getAttribute('aria-busy') === 'true';
      const query = normalize(search.value);
      section.querySelectorAll('[data-wishlist-count]').forEach(count => {
        count.textContent = storageError ? '—' : String(saved.length);
      });
      const title = card => card.dataset.productTitle || card.dataset.productHandle.replace(/-/g, ' ');
      const savedOrder = new Map(saved.map((handle, index) => [handle, index]));
      const sorted = cards.slice().sort((a, b) => {
        if (sort.value === 'title_asc') return collator.compare(title(a), title(b));
        if (sort.value === 'title_desc') return collator.compare(title(b), title(a));
        return (savedOrder.get(a.dataset.productHandle) ?? 0) - (savedOrder.get(b.dataset.productHandle) ?? 0);
      });
      let visible = 0;
      const focused = grid.contains(document.activeElement) ? document.activeElement : null;
      sorted.forEach((card, index) => {
        const next = grid.children[index];
        if (next !== card) {
          if (typeof grid.moveBefore === 'function') grid.moveBefore(card, next || null);
          else grid.insertBefore(card, next || null);
        }
        const matches = !query || normalize(title(card)).includes(query);
        card.hidden = !matches;
        if (matches) visible++;
      });
      if (focused && focused.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
      tools.hidden = storageError || saved.length === 0 || cards.length === 0;
      noResults.hidden = storageError || !query || visible > 0 || busy || cards.length === 0;
      section.classList.toggle('lc-wishlist-is-empty', !storageError && saved.length === 0);
      section.classList.toggle('lc-wishlist-is-busy', busy);
      const message = (results.dataset.template || '').replace('__VISIBLE__', String(visible)).replace('__LOADED__', String(cards.length));
      if (results.textContent !== message) results.textContent = message;
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(refresh);
    }
    function clearSearch() {
      search.value = '';
      refresh();
      search.focus();
    }
    const observer = new MutationObserver(schedule);
    observer.observe(grid, { childList: true, attributes: true, attributeFilter: ['aria-busy', 'hidden'] });
    search.addEventListener('input', schedule);
    sort.addEventListener('change', schedule);
    reset.addEventListener('click', clearSearch);
    document.addEventListener('lc:wishlist-changed', schedule);
    document.addEventListener('lc:wishlist-storage-error', schedule);
    instances.set(section, () => {
      observer.disconnect();
      window.cancelAnimationFrame(frame);
      search.removeEventListener('input', schedule);
      sort.removeEventListener('change', schedule);
      reset.removeEventListener('click', clearSearch);
      document.removeEventListener('lc:wishlist-changed', schedule);
      document.removeEventListener('lc:wishlist-storage-error', schedule);
      instances.delete(section);
    });
    refresh();
  }

  function initialize() {
    document.querySelectorAll('[data-lc-wishlist]').forEach(mount);
  }
  customElements.whenDefined('wishlist-view').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, section) => {
      if (event.target.contains(section)) cleanup();
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
